'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import Pagination from 'Components/Pagination';
import CoworkingSpace from 'Components/Front/CoworkingSpace';
import Loader from 'Pure/Loader';
import truncate from 'Functions/truncate';
import bemit from 'Functions/bemit';
import { getUrlParameter, getMinMaxSeats } from 'Shared/utilities';
import { URL, action } from 'Shared/Routes';
import { coworking_place_types as type_options } from 'Shared/options';
const app = window.app;
const qwest = window.qwest;
export default class SpacesBlock extends Component {
  state = {
    data: [],
    order: this.props['order'] || 'asc',
    order_by: this.props['order-by'] || 'name',
    skip: 0,
    limit: 0,
    title: 'Nos différents espaces de coworking',
    loading: true,
    type: "b_seminar"
  };
  list_ref = React.createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props['search-results'] === true) {
      component.buildSearchResults();
    } else {
      component.fetch({});
    }
    app.push({
      event: 'ScrollToSpaceAvailability',
      cb: component.handleScrollRequest
    });
    app.push({
      event: 'UpdatedSideWidget',
      cb: component.handleSideWidgetChange
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'ScrollToSpaceAvailability',
      cb: component.handleScrollRequest
    });
    app.delete({
      event: 'UpdatedSideWidget',
      cb: component.handleSideWidgetChange
    });
  }
  componentDidUpdate() {
    const component = this,
      props = this.props,
      state = this.state;
    if (component.scroll_requested === true) {
      component.scroll_requested = false;
      window.setTimeout(function () {
        component.handleScrollRequest({});
      }, 120);
    }
  }
  handleSideWidgetChange = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const new_type = window.localStorage.getItem('widget-space-type') || '';
    if (state.type === new_type) {
      if (data.scrollToAvailability === true) {
        component.handleScrollRequest({});
      }
      return;
    }
    component.fetch({
      type: new_type,
      scroll: data.scrollToAvailability === true
    });
  };
  handleScrollRequest = ({
    data,
    source
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.scroll_requested = false;
    const list = component.list_ref?.current;
    if (!list || !list.scrollIntoView) return;
    const position = list.getBoundingClientRect();

    // Block is at the bottom or outside the viewport, so we scroll to it
    if (position.top > 0 && position.bottom > window.innerHeight) {
      list.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    // Block is at the top of the screen, so we scroll upwards
    else if (position.bottom < 0) {
      list.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }
    // Block is partially visible and can be scrolled upwards
    else if (position.top < 0 && position.bottom < window.innerHeight) {
      list.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }
  };
  buildSearchResults = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const searched = getUrlParameter('termes');
    let type = getUrlParameter('type');

    // The type index is used in the url instead of the type value
    type = type_options[parseInt(type) - 1]?.value;
    if (type === 'tous') {
      type = 'all';
    } else if (type === 'seminaires') {
      type = 'b_seminar';
    }
    component.fetch({
      searched,
      type
    });
  };
  fetch = ({
    searched,
    type,
    page,
    scroll = false
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true,
      type: typeof type === 'undefined' ? state.type : type
    });
    qwest.post(action('getAllCoworkingSpaces'), {
      etablishment_id: props['etablishment-id'],
      type: "b_seminar"
    }).then(function (xhr, response) {
      if (scroll === true) {
        component.scroll_requested = true;
      }
      component.setState({
        loading: false,
        data: (response.data || []).map(function (data) {
          data.description = truncate(data.description, 160);
          data.min_max_seats = getMinMaxSeats(data);
          return data;
        }),
        title: props['search-results'] === true ? (response.data?.length || 0) + ' Résultats' : state.title
      });
      if (typeof props.onFetch === 'function') {
        props.onFetch({
          spaces: response.data,
          count: response.count || 0
        });
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const modifiers = ['space'].concat(props.bemit || []);
    const spaces = (state.data || []).map(function (data) {
      const output = /*#__PURE__*/React.createElement(CoworkingSpace, _extends({
        key: data.id,
        source: "offline"
      }, data, {
        bemit: ['space', 'list'],
        "layout-type": "side",
        availability: true,
        selectSpace: props.selectSpace
      }));
      return output;
    });
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white'],
      text: "Chargement..."
    }) : undefined;
    let output = /*#__PURE__*/React.createElement("section", {
      className: bemit('o-spaces-block', modifiers),
      id: props.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__list",
      ref: component.list_ref
    }, spaces?.length < 1 ? /*#__PURE__*/React.createElement("p", null, "Ce myWO ne poss\xE8de pas ce type d'espace") : undefined, spaces, /*#__PURE__*/React.createElement("div", {
      className: "c-media"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-media"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-media"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-media"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-media"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-media"
    })), props.pagination !== false ? /*#__PURE__*/React.createElement(Pagination, {
      current: state.page,
      total: state.data_count,
      "items-per-page": state.rows_per_page,
      onChange: component.handlePageChange,
      bemit: ['spaces-block', 'front'],
      "hide-count": true
    }) : undefined, loader);
    return output;
  }
}
